import { cn } from "@/lib/utils";

// Brand spinner. size in px via className (w-/h-).
function Spinner({ className, ...props }) {
  return (
    <span
      role="status"
      aria-label="Cargando"
      data-kit=""
      className={cn(
        "inline-block h-5 w-5 animate-spin rounded-full border-2 border-primary/25 border-t-primary",
        className
      )}
      {...props}
    />
  );
}

export { Spinner };
